import CURRENT_USER_QUERY from '@/graphql/queries/currentUser.gql';
import SYSTEMS_QUERY from '@/graphql/queries/systems.gql';
import COMPONENT_DATABASES_QUERY from '@/graphql/queries/componentDatabases.gql';
import Btn from '@/components/Btn/Btn.vue';
import Database from '@/components/ManageDatabase/Database/Database.vue';
import Modal from '@/components/Modal/Modal.vue';
import AddSystem from '@/components/ManageDatabase/AddSystem/AddSystem.vue';
import AddComponent from '@/components/ManageDatabase/AddComponent/AddComponent.vue';
import AddDatabase from '@/components/ManageDatabase/AddDatabase/AddDatabase.vue';
import accessByPermissions from '@/services/userPermissions';
import PERMISSIONS from '@/enums/permissions';
import { sortByName } from '@/utils/sortByName';

export default {
  name: 'ManageDatabaseSystems',
  components: { AddSystem, AddComponent, AddDatabase, Modal, Btn, Database },
  apollo: {
    currentUser: {
      query: CURRENT_USER_QUERY,
      fetchPolicy: 'cache-only',
    },
    componentDatabases: {
      query: COMPONENT_DATABASES_QUERY,
      fetchPolicy: 'cache-and-network',
      error(error) {
        this.error = error.networkError ? { ...error, message: 'Something went wrong! Could not load component databases.' } : error;
      },
      result({ data }) {
        if (!this.selectedComponentDatabaseId && data && data.componentDatabases && data.componentDatabases.length) {
          this.selectedComponentDatabaseId = data.componentDatabases[0].id;
        }
      },
    },
    systems: {
      query: SYSTEMS_QUERY,
      fetchPolicy: 'cache-and-network',
      variables() {
        return { componentDatabaseId: this.selectedComponentDatabaseId };
      },
      skip() {
        return !this.selectedComponentDatabaseId;
      },
      error(error) {
        this.error = error.networkError ? { ...error, message: 'Something went wrong! Could not load systems components.' } : error;
      },
      update(data) {
        return data.systems.sort(sortByName);
      },
    },
  },
  data: () => ({
    currentUser: null,
    componentDatabases: [],
    selectedComponentDatabaseId: null,
    systems: [],
    error: null,
  }),
  computed: {
    systemsLoading() {
      return this.$apollo.queries.systems.loading;
    },
    showAddDatabaseBtn() {
      return accessByPermissions(PERMISSIONS.CREATE_COMPONENT_DATABASE, this.currentUser);
    },
    showAddSystemBtn() {
      return accessByPermissions(PERMISSIONS.CREATE_SYSTEM, this.currentUser);
    },
    showAddComponentBtn() {
      return accessByPermissions(PERMISSIONS.CREATE_DATABASE_COMPONENT, this.currentUser);
    },
  },
};
